import {
  ElectionOutcome,
  IOutcomeNumberMap,
  IPartyNumberMap
} from '../models/TypeHelper'
import PartyResultMap from './PartyResultMap'
import Coalition from './Coalition'

export interface IPartyOutcomeCountMap {
  [partyKey: string]: IOutcomeNumberMap
}

export interface IOutcomeCountMap {
  [outcome: string]: number
}

export interface IOutcomePartyCountMap {
  [electionOutcome: string]: IPartyNumberMap
}

export interface ICoalitionCount {
  // [key: string]: { possible: number; required: number }
  [comboKey: string]: number
}

export default class OutcomeController {
  protected _outcomes: PartyResultMap[]

  public constructor(outcomes: PartyResultMap[]) {
    this._outcomes = outcomes
  }

  public outcomesByParty = (): IPartyOutcomeCountMap => {
    const partyOutcomeCounts: IPartyOutcomeCountMap = {}

    this._outcomes.forEach((outcome): void => {
      Object.values(outcome.results()).forEach((partyResult): void => {
        partyOutcomeCounts[partyResult.party.code] =
          partyOutcomeCounts[partyResult.party.code] || {}

        partyOutcomeCounts[partyResult.party.code][partyResult.outcome] =
          partyOutcomeCounts[partyResult.party.code][partyResult.outcome] + 1 ||
          1
      })
    })

    return partyOutcomeCounts
  }

  public partiesByOutcome = (): IOutcomePartyCountMap => {
    const counts: IOutcomePartyCountMap = {}

    const ties: string[] = []
    this._outcomes.forEach((outcome): void => {
      const tiedParties: string[] = []
      Object.values(outcome.results()).forEach((partyResult): void => {
        const outcome = partyResult.outcome
        const partyCode = partyResult.party.code
        if (outcome === 'tie') {
          tiedParties.push(partyCode)
        } else {
          counts[outcome] = counts[outcome] || {}

          counts[outcome][partyCode] = counts[outcome][partyCode] + 1 || 1
        }
      })
      if (tiedParties.length) ties.push(tiedParties.sort().join('-'))
    })

    if (ties.length) {
      counts['tie'] = {}
      ties.forEach((tiedPartyKeys: string): void => {
        counts['tie'][tiedPartyKeys] = counts['tie'][tiedPartyKeys] + 1 || 1
      })
    }

    return counts
  }

  public filterByResult(
    desiredResult: ElectionOutcome | ElectionOutcome[]
  ): PartyResultMap[] {
    // Transform to ElectionOutcome[] in any case
    if (!Array.isArray(desiredResult)) desiredResult = [desiredResult]
    return this._outcomes.filter((partyResultMap: PartyResultMap): boolean => {
      const outcomes = Object.values(
        partyResultMap.outcomes()
      ) as ElectionOutcome[]
      return outcomes.some((electionOutcome: ElectionOutcome): boolean =>
        desiredResult.includes(electionOutcome)
      )
    })
  }

  public buildCoalitions(): { [comboKey: string]: number } {
    const minorityOutcomes = this.filterByResult(['minority', 'tie'])

    const allCoalitions: Coalition[] = []

    // Now we have all minority outcomes. For each one, find out which
    // coalitions would work.
    minorityOutcomes.forEach((outcome): void => {
      outcome.findMajorities().forEach((coalition): void => {
        allCoalitions.push(Coalition.fromPartyResultList(coalition))
      })
    })

    console.log('allCoalitions', allCoalitions)

    const uniqueMappedResults: { [comboKey: string]: number } = {}

    allCoalitions.forEach((coalition): void => {
      const uniqueStr = coalition.uniqueStringRepresentation
      uniqueMappedResults[uniqueStr] = uniqueMappedResults[uniqueStr] + 1 || 1
    })

    console.log('uniquemappedresults', uniqueMappedResults)

    const finalResults: { [comboKey: string]: number } = {}

    allCoalitions.forEach((coalition): void => {
      const uniqueStr = coalition.uniqueStringRepresentation
      finalResults[uniqueStr] = uniqueMappedResults[uniqueStr]
      const parent = coalition.getParent()
      if (parent) {
        const parentUniqueStr = parent.uniqueStringRepresentation
        finalResults[uniqueStr] += uniqueMappedResults[parentUniqueStr] || 0
      }
    })

    console.log(finalResults)
    console.log('----------------')

    return finalResults
  }

  public static hasResult(
    partyCounts: IOutcomePartyCountMap,
    key: string
  ): boolean {
    return (
      partyCounts[key] !== undefined && Object.keys(partyCounts[key]).length > 0
    )
  }

  // public outcomesByResult = (): IOutcomeCountMap => {
  //   const outcomeCounts: IOutcomeCountMap = {}

  //   this._outcomes.forEach((outcome): void => {
  //     console.log(Object.values(outcome.outcomes()))
  //     // Object.values(outcome.outcomes()).forEach((o: ElectionOutcome): void => {
  //     //   console.log(o)
  //     // }
  //   })

  //   return outcomeCounts
  // }
}
